import { createEntityAdapter, createSlice } from '@reduxjs/toolkit'
import { find } from 'lodash-es'
import ActionTypes from '@constants/action_types.js'

const combiTimelineViewsAdapter = createEntityAdapter()

// create initial state for the views slice and include a view to act as the default view
const initialState = combiTimelineViewsAdapter.getInitialState({
  ids: [],
  entities: {},
})

const slice = createSlice({
  name: 'combiTimelineViews',
  initialState,
  extraReducers: builder => {
    builder.addCase(ActionTypes.RECEIVE_ENTITIES, (state, action) => {
      const { payload } = action
      if (payload.hasOwnProperty('combi_timeline_views')) {
        combiTimelineViewsAdapter.upsertMany(state, payload.combi_timeline_views)
      }
    })
  },
})

// Selectors

export const combiTimelineViewsSelectors = combiTimelineViewsAdapter.getSelectors(
  state => state.data.combiTimelineViews
)

export const getCombiTimelineView = (state, props) => {
  const { combiTimelineViewId } = props
  const allEntities = combiTimelineViewsSelectors.selectAll(state)
  return find(allEntities, entity => {
    const result = entity.id.toString() === combiTimelineViewId.toString()
    return result
  })
}

export default slice.reducer
